import instance from '../utils/axios';

class ActivityListService {
    async getActivityList(dictionaryNames,expressions,pageSize,pageIndex) {
        return await instance.post('/crm/activity/list',{
            dictionaryNames:dictionaryNames,
            expressions:expressions,
            pageIndex:pageIndex,
            pageSize:pageSize
        });
    }
    async getActivityTypeId() {
        return await instance.get('/crm/common/CommonApi/GetZLSelectDict?dictionaryName=dict_activity_type');
    }
    async getActivityDetail(id) {
        return await instance.get('/crm/activity/getById?uuid=' + id);
    }
    async getActivityCustomerList(dictionaryNames,expressions,pageSize,pageIndex,uuid) {
        return await instance.post('/crm/activity/getAppointmentCustomer',{
            dictionaryNames:dictionaryNames,
            expressions:expressions,
            pageIndex:pageIndex,
            pageSize:pageSize,
            activityId:uuid
        });
    }
    async getHiddenFields(activityId) {
        return await instance.get('/crm/activity/listInfo/getHiddenFieldDescriptionList?activityId=' + activityId);
    }
}
export default new ActivityListService();